// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__pjiXd","list":"styles_list__15GC3"};